document.addEventListener('DOMContentLoaded', function() {
    var page = 2; // Bắt đầu tải từ trang 2
    var loading = false;

    // Kiểm tra khi người dùng cuộn tới đáy trang
    window.addEventListener('scroll', function() {
        if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight - 100) {
            if (!loading) {
                loading = true;
                var collectionUrl = window.location.href + '?page=' + page;
                fetch(collectionUrl)
                    .then(response => response.text())
                    .then(html => {
                        var doc = new DOMParser().parseFromString(html, 'text/html');
                        var newProducts = doc.querySelectorAll('.grid-product'); // Chỉnh lại selector nếu cần
                        newProducts.forEach(function(product) {
                            document.querySelector('.grid').appendChild(product); // Thêm sản phẩm vào lưới
                        });
                        page++; // Tăng số trang để tải thêm
                        loading = false;
                    })
                    .catch(function(error) {
                        console.error('Error loading more products:', error);
                        loading = false;
                    });
            }
        }
    });
});
